import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import { WithApp } from 'contexts/appContext';
import { Close, KeyboardBackspace } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
    backgroundColor: '#8e24aa'
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1
  },
  contClose: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '3px',
    background: '#323639',
    paddingLeft: '10px',
    color: 'white'
  },
  close: {
    backgroundColor: '#1ecde5',
    borderRadius: '7px',
    width: '55px',
    '&:hover': {
      backgroundColor: '#16a9bd',
      cursor: 'pointer'
    }
  },
  exit: {
    backgroundColor: '#ff0028',
    borderRadius: '7px',
    width: '55px',
    '&:hover': {
      backgroundColor: '#ff0028db',
      cursor: 'pointer'
    }
  }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default WithApp(function FullScreenDialog(props) {
  const classes = useStyles();
  const { open, setOpen, title, iframe, containerStyle } = props;

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
        {!!iframe ? (
          <>
            <div className={classes.contClose}>
              <KeyboardBackspace className={classes.close} onClick={handleClose} />
              <Close className={classes.exit} onClick={handleClose} />
            </div>
            <>{props.children}</>
          </>
        ) : (
          <>
            <AppBar className={classes.appBar}>
              <Toolbar>
                <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                  <CloseIcon />
                </IconButton>
                <Typography variant="h6" className={classes.title}>
                  {title}
                </Typography>
              </Toolbar>
            </AppBar>
            <div style={{ padding: '15px', ...containerStyle }}>{props.children}</div>
          </>
        )}
      </Dialog>
    </div>
  );
});
